import { render } from "./DashboardGeneral.vue?vue&type=template&id=04e06e38&scoped=true"
import script from "./DashboardGeneral.vue?vue&type=script&lang=js"
export * from "./DashboardGeneral.vue?vue&type=script&lang=js"

import "./DashboardGeneral.vue?vue&type=style&index=0&id=04e06e38&scoped=true&lang=css"
import "../../assets/css/staff-editor-dialog.css?vue&type=style&index=1&id=04e06e38&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e06e38"]])

export default __exports__